import { Dispatch, SetStateAction, useEffect, useState } from 'react'

export function useLocalStorageState<ValueType>(
  storageKey: string,
  initialValue: ValueType,
): [ValueType, Dispatch<SetStateAction<ValueType>>] {
  function isPrevStateFunction(
    setStateAction: SetStateAction<ValueType>,
  ): setStateAction is (prevState?: ValueType) => ValueType {
    return typeof setStateAction === 'function'
  }

  const getLocalStorageValue = () => {
    const valueString = window.localStorage.getItem(storageKey)
    return valueString ? JSON.parse(valueString) : null
  }

  const [value, setValue] = useState<ValueType>(getLocalStorageValue() ?? initialValue)

  const handleSetValue: Dispatch<SetStateAction<ValueType>> = setStateAction => {
    let newValue = setStateAction
    if (isPrevStateFunction(setStateAction)) {
      newValue = setStateAction(value)
    }
    window.localStorage.setItem(storageKey, JSON.stringify(newValue))

    setValue(newValue)
  }

  useEffect(() => {
    const storageValue = getLocalStorageValue()
    if (storageValue !== null && storageValue !== value) {
      handleSetValue(storageValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageKey])

  return [value, handleSetValue]
}
